/**
 * MoonSphere Component
 * Renders the Moon sphere with material
 */

import React, { useEffect, useMemo } from 'react'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'
import { DEFAULT_SPHERE_SEGMENTS } from './utilities/moonConstants'

export function MoonSphere({
  radius = 0.273,
  segments = DEFAULT_SPHERE_SEGMENTS,
  quality = 'LOD_3',
  rotation = [0, 0, 0],
  position = [0, 0, 0],
  materialCache = {},
  shadows = true,
}) {
  const { gl } = useThree()
  const isWebGPU = gl.isWebGPURenderer || false

  // Get material from cache
  const material = materialCache[quality]?.moon || null

  // Create geometry once using useMemo
  const moonGeometry = useMemo(() => {
    const geom = new THREE.SphereGeometry(radius, segments, segments)
    geom.computeTangents()
    return geom
  }, [radius, segments])

  // Cleanup geometry on unmount
  useEffect(() => {
    return () => {
      moonGeometry.dispose()
    }
  }, [moonGeometry])

  // Don't render until material is ready
  if (!material) {
    return null
  }

  return (
    <mesh
      geometry={moonGeometry}
      rotation={rotation}
      position={position}
      castShadow={shadows}
      receiveShadow={shadows}
    >
      <primitive object={material} attach="material" />
    </mesh>
  )
}

export default MoonSphere
